import { select } from "@fruugo/utilities";
import { i18n } from "./i18n";

export const renderGradeDescription = () => {
  const gradeDescription = select<HTMLElement>(".js-grade-description");
  if (!gradeDescription) return;

  const remainder = gradeDescription.querySelector<HTMLElement>(
    ".js-grade-description-remainder"
  );
  const button = gradeDescription.querySelector<HTMLButtonElement>(
    ".js-grade-description-toggle"
  );
  const buttonText = button?.querySelector("#grade-description-button-text");
  const buttonIcon = button?.querySelector("#grade-description-chevron");

  if (!remainder || !button || !buttonText) return;

  remainder.classList.add("tw:hidden");
  button.setAttribute("aria-expanded", "false");

  button.addEventListener("click", () => {
    const isExpanded = button.getAttribute("aria-expanded") === "true";

    remainder.classList.toggle("tw:hidden", isExpanded);
    button.setAttribute("aria-expanded", String(!isExpanded));
    buttonText.textContent = isExpanded
      ? i18n("generic.show-more")
      : i18n("generic.show-less");
    buttonIcon?.classList.toggle("tw:rotate-180", !isExpanded);
  });
};
